/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Feat_2_DescInputs */

const en_nfp_feat_2_desc = /** @type {(inputs: Nfp_Feat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload your charity registration once. We automatically generate compliant PDF receipts for every donation, ticket, or asset sold.`)
};

const es_nfp_feat_2_desc = /** @type {(inputs: Nfp_Feat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube el registro de tu organización benéfica una sola vez. Generamos automáticamente recibos PDF que cumplen con la normativa.`)
};

const fr_nfp_feat_2_desc = /** @type {(inputs: Nfp_Feat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargez l'enregistrement de votre association une seule fois. Nous générons automatiquement des reçus PDF conformes pour chaque don, billet ou bien vendu.`)
};

const de_nfp_feat_2_desc = /** @type {(inputs: Nfp_Feat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade die Registrierung deiner Wohltätigkeitsorganisation hoch. Wir generieren automatisch konforme PDF-Quittungen.`)
};

const id_nfp_feat_2_desc = /** @type {(inputs: Nfp_Feat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah pendaftaran amal Anda sekali saja. Kami akan secara otomatis menghasilkan tanda terima PDF yang patuh untuk setiap donasi, tiket, atau aset yang dijual.`)
};

/** @type {(inputs: Nfp_Feat_2_DescInputs) => LocalizedString} */
const ja_nfp_feat_2_desc = en_nfp_feat_2_desc;

/** @type {(inputs: Nfp_Feat_2_DescInputs) => LocalizedString} */
const zh_nfp_feat_2_desc = en_nfp_feat_2_desc;

/** @type {(inputs: Nfp_Feat_2_DescInputs) => LocalizedString} */
const ar_nfp_feat_2_desc = en_nfp_feat_2_desc;

/** @type {(inputs: Nfp_Feat_2_DescInputs) => LocalizedString} */
const it_nfp_feat_2_desc = en_nfp_feat_2_desc;

/** @type {(inputs: Nfp_Feat_2_DescInputs) => LocalizedString} */
const ru_nfp_feat_2_desc = en_nfp_feat_2_desc;

/** @type {(inputs: Nfp_Feat_2_DescInputs) => LocalizedString} */
const pt_nfp_feat_2_desc = en_nfp_feat_2_desc;

/** @type {(inputs: Nfp_Feat_2_DescInputs) => LocalizedString} */
const ko_nfp_feat_2_desc = en_nfp_feat_2_desc;

/**
* | output |
* | --- |
* | "Upload your charity registration once. We automatically generate compliant PDF receipts for every donation, ticket, or asset sold." |
*
* @param {Nfp_Feat_2_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_feat_2_desc = /** @type {((inputs?: Nfp_Feat_2_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Feat_2_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_feat_2_desc(inputs)
	if (locale === "es") return es_nfp_feat_2_desc(inputs)
	if (locale === "fr") return fr_nfp_feat_2_desc(inputs)
	if (locale === "de") return de_nfp_feat_2_desc(inputs)
	if (locale === "ja") return ja_nfp_feat_2_desc(inputs)
	if (locale === "zh") return zh_nfp_feat_2_desc(inputs)
	if (locale === "ar") return ar_nfp_feat_2_desc(inputs)
	if (locale === "id") return id_nfp_feat_2_desc(inputs)
	if (locale === "it") return it_nfp_feat_2_desc(inputs)
	if (locale === "ru") return ru_nfp_feat_2_desc(inputs)
	if (locale === "pt") return pt_nfp_feat_2_desc(inputs)
	return ko_nfp_feat_2_desc(inputs)
});